import React from 'react';
import { useTranslation } from 'next-i18next';
import { type UserProfileProps } from '../types';
import { ProfileShareButton } from './ProfileActionButton';
import { ProfileCard } from './ProfileCard';
export const UserProfile = (user: UserProfileProps) => {
  const {
    t
  } = useTranslation(['common']);
  const userName = t('common:profile.byUserQuiz', {
    name: user.name
  });
  return <ProfileCard user={{
    ...user,
    name: userName
  }} actions={<ProfileShareButton event={{
    location: 'user',
    userEmail: user.email ?? '',
    username: String(user.name)
  }} userHashId={user.userHashId} key={'share'} />} data-sentry-element="ProfileCard" data-sentry-component="UserProfile" data-sentry-source-file="UserProfile.tsx" />;
};